import { Accordion } from "@mui/material"
import { styled } from "@mui/material"

const StyledAccordion = styled(Accordion)`
    background-color: ${({theme}) => theme.palette.greyLight.main}
    
`

export default StyledAccordion
